import { render, staticRenderFns } from "./activities-holidays.vue?vue&type=template&id=2397013c&scoped=true&"
import script from "./activities-holidays.vue?vue&type=script&lang=js&"
export * from "./activities-holidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397013c",
  null
  
)

export default component.exports